import { render, staticRenderFns } from "./auction-house-card.vue?vue&type=template&id=bda175dc&scoped=true&"
import script from "./auction-house-card.vue?vue&type=script&lang=js&"
export * from "./auction-house-card.vue?vue&type=script&lang=js&"
import style0 from "./auction-house-card.vue?vue&type=style&index=0&id=bda175dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda175dc",
  null
  
)

export default component.exports